import React from 'react';
import { useOnlineStatus, useStorageMonitor, formatStorageSize } from '../utils/offlineUtils';

const OfflineIndicator: React.FC = () => {
  const isOnline = useOnlineStatus();
  const { estimate, warningLevel, percentage } = useStorageMonitor();

  if (isOnline && warningLevel === 'none') {
    return null;
  }

  const getStorageMessage = () => {
    if (!estimate || !estimate.quota || !estimate.usage) return null;

    const used = formatStorageSize(estimate.usage);
    const total = formatStorageSize(estimate.quota);
    const percent = (percentage * 100).toFixed(1);

    if (warningLevel === 'critical') {
      return `Storage critically low: ${used} / ${total} (${percent}%). Clear data to free space.`;
    }
    if (warningLevel === 'warning') {
      return `Storage running low: ${used} / ${total} (${percent}%). Consider clearing old data.`;
    }
    return null;
  };

  const storageMessage = getStorageMessage();

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-500 text-white px-4 py-2 text-center text-sm font-medium">
      {!isOnline && (
        <div className="mb-1">
          <span className="inline-flex items-center">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            You're offline. Changes will be saved locally and synced when connection returns.
          </span>
        </div>
      )}
      {storageMessage && (
        <div className="text-xs opacity-90">
          {storageMessage}
        </div>
      )}
    </div>
  );
};

export default OfflineIndicator;
